import React from 'react';
import SuspireCircle from '../components/SuspireCircle/SuspireCircle';

export default function InternalMessagesPage() {
  return <SuspireCircle />;
}
